export default __webpack_public_path__ + "c2d7a030b63086804aed70aec8a3aec6.png";